import { EntityStatusTypes } from "@enums/entity-status-types";
import { ApAssertionStatusMap } from "@idw-types/data/ap-assertion-status-map/ap-assertion-status-map";
import { FormattedRpServiceConfigurationServiceOfferingAssertion } from "@idw-types/data/rp-service-configuration";
import {
    FormattedRpServiceConfigurationScoreModifier,
    RpServiceConfigurationScoreModifier
} from "@idw-types/data/rp-service-configuration/rp-service-configuration-score";
import { FormattedRpServiceConfigurationServiceOffering } from "@idw-types/data/rp-service-configuration/rp-service-configuration-service-offering";

import {
    getActiveAssertionStatus,
    getActiveServiceOfferings,
    getAssertionStatusIDS,
    getValidApAssertionIDS,
    getValidServiceOfferingIDS,
    mapAssertionScoreModifiersByID
} from "@utils/scores/score-util";

export const formatScoreModifiers = (
    scoreModifiers: Array<RpServiceConfigurationScoreModifier>,
    serviceOfferings: Array<FormattedRpServiceConfigurationServiceOffering>,
    assertionStatusMaps: Array<ApAssertionStatusMap>
) => {
    const finalScoreModifiers: FormattedRpServiceConfigurationScoreModifier[] = [];
    let assertionScoreModifierMap: {
        [key: string]: RpServiceConfigurationScoreModifier;
    };

    if (scoreModifiers.length > 0) {
        assertionScoreModifierMap = mapAssertionScoreModifiersByID(
            scoreModifiers
        );
    }
    const activeServiceOfferings = getActiveServiceOfferings(serviceOfferings);
    const validServiceOfferingIDS = getValidServiceOfferingIDS(
        activeServiceOfferings
    );
    const validAPAssertionIDs = getValidApAssertionIDS(serviceOfferings);

    const assertionStatuses = getActiveAssertionStatus(
        validServiceOfferingIDS,
        validAPAssertionIDs,
        assertionStatusMaps
    );
    activeServiceOfferings.forEach((serviceOffering) => {
        const { assertions } = serviceOffering;

        assertions.forEach((assertion) => {
            if (assertion.status === EntityStatusTypes.ACTIVE) {
                finalScoreModifiers.push(
                    formatScoreModifier(
                        assertion,
                        assertionScoreModifierMap,
                        assertionStatuses,
                        scoreModifiers
                    )
                );
            }
        });
    });

    return finalScoreModifiers;
};

export const formatScoreModifier = (
    assertion: FormattedRpServiceConfigurationServiceOfferingAssertion,
    assertionScoreModifierMap: {
        [key: string]: RpServiceConfigurationScoreModifier;
    },
    assertionStatuses: Array<ApAssertionStatusMap>,
    assertionScoreModifiers: Array<RpServiceConfigurationScoreModifier>
) => {
    const assertionStatusIDs = getAssertionStatusIDS(
        assertionStatuses,
        assertion.assertionId
    );

    if (assertionScoreModifiers.length > 0 && assertionScoreModifierMap[assertion.assertionId]) {
        return {
            ...assertionScoreModifierMap[assertion.assertionId],
            assertionID: assertion.assertionId,
            apAssertionID: assertion.apAssertionId,
            serviceOfferingIDs: [assertion.serviceOfferingID],
            assertionStatusIDs,
           
        };
    } else {
        return {
            id: undefined,
            assertionID: assertion.assertionId,
            apAssertionID: assertion.apAssertionId,
            serviceOfferingIDs: [assertion.serviceOfferingID],
            assertionStatusIDs,
            passScore: "",
            closeScore: "",
            partialScore: "",
            unverifiedScore: "",
            failScore: "",
            warnScore: "",
        };
    }
};
